module.exports = "<div class=ibox-tools uib-dropdown> <a ng-click=showhide()> <i class=\"fa fa-chevron-up\"></i></a> </div>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/views/common/ibox_tools.html
// module id = 4188
// module chunks = 86